import {
  IconDashboard,
  IconUpload,
  IconPackage,
  IconAlert,
  IconVault,
  IconInbox,
  IconChart,
} from '../../ui/icons';
import { WorkspaceNav } from '../WorkspaceNav';

/**
 * Icon-rail navigation for the Originator workspace.
 * Routes/labels mirror the existing OriginatorSidebar — no route paths change.
 */
const allSections = [
  {
    items: [
      { to: '/', label: 'Dashboard', Icon: IconDashboard, end: true },
      { to: '/submission/new', label: 'New Submission', Icon: IconUpload },
      { to: '/packages', label: 'Packages', Icon: IconPackage },
      { to: '/exceptions', label: 'Exceptions', Icon: IconAlert },
    ],
  },
  {
    items: [
      { to: '/loans', label: 'Loans / Assets', Icon: IconVault },
      { to: '/requests', label: 'Requests', Icon: IconInbox },
    ],
  },
  {
    items: [{ to: '/reports', label: 'Reports', Icon: IconChart }],
  },
];

export function OriginatorIconRail() {
  return <WorkspaceNav ariaLabel="Originator navigation" sections={allSections} />;
}
